import { createFileRoute } from "@tanstack/react-router";
import { SuppliersContactsPage } from "../../../../pages/suppliers-page/suppliers-contacts-page";

export const Route = createFileRoute("/_auth/_frame/suppliers/contacts")({
  component: SuppliersContactsPage,
});
